import PhotoCard from "./PhotoCard";

export default function PhotoGrid({
  photos,
  categorie,
  label,
  onUpdateLegende,
  onRemove,
  onReorder,
}) {
  const filtered = photos.filter((p) => p.categorie === categorie);

  if (filtered.length === 0) return null;

  const handleMove = (index, direction) => {
    const items = filtered.map((p, i) => ({ id: p.id, ordre: i }));
    const target = index + direction;
    if (target < 0 || target >= items.length) return;
    // Swap
    [items[index].ordre, items[target].ordre] = [items[target].ordre, items[index].ordre];
    onReorder(items);
  };

  return (
    <div>
      <h3 className="text-sm font-semibold text-slate-700 mb-3">
        {label}
        <span className="ml-2 text-xs font-normal text-slate-400">
          ({filtered.length})
        </span>
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {filtered.map((photo, i) => (
          <PhotoCard
            key={photo.id}
            photo={photo}
            index={i}
            isFirst={i === 0}
            isLast={i === filtered.length - 1}
            onUpdateLegende={(legende) => onUpdateLegende(photo.id, legende)}
            onRemove={() => onRemove(photo.id)}
            onMoveUp={() => handleMove(i, -1)}
            onMoveDown={() => handleMove(i, 1)}
          />
        ))}
      </div>
    </div>
  );
}
